/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

function expandReviewWall(trigger) {
  const wall = trigger.closest('.review-wall');
  if (!wall) return;

  const masonry = wall.querySelector('.review-masonry');
  const deferred = wall.querySelector('template[data-review-wall-deferred]');

  if (masonry && deferred?.content?.children.length) {
    masonry.appendChild(deferred.content.cloneNode(true));
    deferred.remove();
  }

  wall.classList.add('is-expanded');
  trigger.closest('.review-wall__actions')?.remove();
}

document.addEventListener(
  'click',
  (event) => {
    const trigger = event.target.closest('.review-wall__view-all, [data-review-wall-view-all]');
    if (!trigger) return;

    event.preventDefault();
    expandReviewWall(trigger);
  },
  true
);
